import { ComponentProps, useRef } from "react";
import { useMatch, useSearchParams } from "react-router-dom";
import { DashboardPage, getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages, useSynchronizeUrl } from "./common";
import type { IFrame } from "components/atoms/IFrame";
import { Message } from "messages";

const useDashboardAdapter = (
  page: DashboardPage,
  messageHandler: (
    ref: React.MutableRefObject<HTMLIFrameElement | null>
  ) => (message: Message | undefined) => Message | undefined
): ComponentProps<typeof IFrame> => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const [searchParams] = useSearchParams();
  const config = getMFEConfig("dashboard", page);
  const basePath = config.iFrameUrl;
  const match = useMatch(`${config.containerPath}/*`);
  const splat = match?.params["*"] ?? "";
  const search = searchParams.toString();
  const src = `${basePath}${splat ? `/${splat}` : ""}${
    search ? `?${search}` : ""
  }`;
  const { staticSrc } = useSynchronizeUrl(ref, src, basePath);
  useIframeMessages(
    ref,
    "Dashboard",
    config.containerPath,
    messageHandler(ref)
  );
  return {
    ref,
    basePath: basePath,
    src: staticSrc,
    title: config.title,
  };
};

export { useDashboardAdapter };
